import React from "react";
import { Collapse } from "@mui/material";
import { cn } from "@helpers/utils";
import { useBaseCollapseContext } from "./context";
import { BaseCollapseBodyProps } from "./types";

/**
 * BaseCollapse.Body - Modular body component for BaseCollapse
 * Must be used within BaseCollapse when using the composable API.
 */
export const BaseCollapseBody = ({ children, className }: BaseCollapseBodyProps) => {
    const { isOpen } = useBaseCollapseContext();

    return (
        <Collapse in={isOpen && !!children}>
            <div
                className={cn(
                    "border-t-[1px] border-t-inputs-border-default space-y-1 p-[16px]",
                    className
                )}
                style={{ borderTopWidth: "1px", borderTopStyle: "solid" }}
            >
                {children}
            </div>
        </Collapse>
    );
};


